import { Component, OnInit } from '@angular/core';

import { first } from "rxjs/operators";
import { LigneFinancement } from "src/app/parametrage/core/model/ligneFinancement/ligneFinancement";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { LigneFinancementSecteur } from 'src/app/parametrage/core/model/ligneFinancement/ligneFinancementSecteur';
import { LigneFinancementSecteurService } from 'src/app/parametrage/core/service/ligne-financement/ligne-financement-secteur.service';
import { LigneFinancementMarcheService } from 'src/app/parametrage/core/service/ligne-financement/ligne-financement-marche.service';
import { LigneFinancementMarche } from 'src/app/parametrage/core/model/ligneFinancement/ligneFinancementMarche';
import { ActivityArea } from 'src/app/parametrage/core/model/activity-area';
import { ActivityAreaService } from 'src/app/parametrage/core/service/activity-area.service';

@Component({
  selector: "app-add-ligne-financement-secteur",
  templateUrl: "./add-ligne-financement-secteur.component.html",
  styleUrls: ["./add-ligne-financement-secteur.component.scss"]
})
export class AddLigneFinancementSecteurComponent implements OnInit {
  ligneFinancement: LigneFinancementSecteur = new LigneFinancementSecteur();
  ligneFinancementMarche: LigneFinancementMarche[];
  secteurs: ActivityArea[];

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _ligneFinancementSecteureService: LigneFinancementSecteurService,
    private _ligneFinancementMarcheService: LigneFinancementMarcheService,
    private _activityAreaService: ActivityAreaService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      montant: [null, Validators.compose([Validators.nullValidator])],
      libelle: [null, Validators.compose([Validators.required])],
      ligneFinancementMarcheId: [
        null,
        Validators.compose([Validators.required])
      ],
      activityAreaId: [null, Validators.compose([Validators.required])]
    });
  }

  ngOnInit() {
    this.getAll(), this.getSecteur();
  }

  save(): void {
    this.pressButton = true;
    this.ligneFinancement = this.form2.value;

    this._ligneFinancementSecteureService
      .add(this.ligneFinancement)
      .pipe(first())
      .subscribe(
        data => {
          this.pressButton = false;
          this.activeModal.close();
        },
        error => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }

  getAll() {
    this._ligneFinancementMarcheService
      .getAllLigneFinancementMarche()
      .subscribe(
        data => {
          this.ligneFinancementMarche = data;
        },
        error => {
          console.log(error);
        }
      );
  }

  getSecteur() {
    this._activityAreaService.getAllSecteurs().subscribe(
      data => {
        this.secteurs = data;
      },
      error => {
        console.log(error);
      }
    );
  }
}
